import axios from 'axios';
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: process.env.VITE_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

request.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('请求拦截器错误：', error);
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('game');
      localStorage.removeItem('gameName');
      window.location.href = '/login';
    }
    Message.error(error.response.data.error || 'Server error, please try again later.');
    return Promise.reject(error.response.data.error);
  }
);

export default request;